module.exports = __webpack_public_path__ + "img/Steor-Icons-15.f5ac7d8b.svg";